import { twMerge } from 'tailwind-merge';
import IconButton from '../Buttons/IconButton';
import { Close } from '../Icons';

type NotificationProps = {
  id: string,
  message: string,
  variant: 'danger' | 'success' | 'warning',
  onClose: () => void,
  className?: string,
};

const Notification = ({
  id, message, variant, onClose, className, ...rest
}: NotificationProps) => {
  const klasses = twMerge(
    'flex justify-between items-center px-6 py-5 lg:py-1 text-black text-sm',
    'transition-all animate-slide-in-top lg:animate-slide-in-bottom',
    variant === 'danger' && 'bg-rose-100',
    variant === 'success' && 'bg-teal-60',
    variant === 'warning' && 'bg-amber-60',
    className,
  );

  return (
    <div className={klasses} {...rest}>
      <p>{message}</p>
      <IconButton
        icon={<Close />}
        variant="embedded"
        onClick={onClose}
      />
    </div>
  );
};

export default Notification;
